// THIS FILE IS GOING TO BE OVERWRITTEN ON BUILD SERVER
var port = 5005

// useful to test from real mobile device while running dev server
var apiRoot =
  window.location.protocol + '//' + window.location.hostname + ':' + port

if (process.env.API.ROOT) {
  apiRoot = process.env.API.ROOT
}

// ToDo: serhii ivanov get chat url from client side
var config = {
  url: apiRoot,
  sourceUrl: window.location.protocol + '//' + window.location.host
}
// Home
config.getHomePageSettings = config.url + '/api/home'
config.getFacebookDeepLink = config.url + '/api/home/getFacebookDeepLink'
config.isDemoCustomer = config.url + '/api/home/isDemoUser'
config.getDeletedInfo = config.url + '/api/home/get-deleting-info'
//
config.getcompanyData = config.url + '/api/company/get'
config.getcompanyVideo = config.url + '/api/company/getVideos'
// Brochure
config.getBrochureMakes = config.url + '/api/brochure/getMake'
config.getBrochureModels = config.url + '/api/brochure/getModel'
config.getBrochureYears = config.url + '/api/brochure/getYear'
config.getBrochures = config.url + '/api/brochure/getBrochures'
config.addBrochure = config.url + '/api/brochure/addOpenedBrochures'
config.loadBrochureHistory = config.url + '/api/brochure/getHistory'

// Owner manual
config.getOwnerMakes = config.url + '/api/ownerManual/getMake'
config.getOwnerModels = config.url + '/api/ownerManual/getModel'
config.getOwnerYears = config.url + '/api/ownerManual/getYear'
config.getOwners = config.url + '/api/ownerManual/getOwners'
config.addOwner = config.url + '/api/ownerManual/addOpenedOwner'
config.loadOwnerHistory = config.url + '/api/ownerManual/getHistory'

config.getAboutData = config.url + '/api/user/about'
config.getAboutUsData = config.url + '/api/company/getAboutUs'
config.getCustomer = config.url + '/api/things/getCustomer'
config.userProfile = config.url + '/api/profile'
config.uploadFile = config.url + '/api/uploads'
config.downloadVCF = config.url + '/api/uploads/VCF'
config.getNotificationsSettings = config.url + '/api/notifications/getSettings'
config.saveNotificationsSettings = config.url + '/api/notifications/saveSettings'

// Recommend A Friend
config.recommendFriendHistory = config.url + `/api/recommend/get-referral-program-history`
config.recommendFriendShare = config.url + '/api/recommend/send-invite'
config.getReferralInfo = config.url + '/api/recommend/get-referral-program-info'
config.recommendFriendHistoryStatuses = config.url + '/api/recommend/get-referral-program-statuses'
config.recommendFriendTerms = config.url + '/api/recommend/get-active-program/terms'
config.recommendFriendShareLink = config.url + '/api/recommend/get-referral-link'
config.recommendFriendShareLinkWithCode = config.url + '/api/recommend/get-referral-link-with-code'
config.recommendFriendSendShareLink = config.url + '/api/recommend/sent-referral-link'
config.addReferral = config.url + '/api/recommend/referral-add'
config.editReferral = config.url + '/api/recommend/referral-edit'
config.deleteReferral = config.url + '/api/recommend/referral-delete'
config.getReferralMessage = config.url + '/api/recommend/get-referral-message'
config.getReferral = config.url + '/api/recommend/referral-get'

// Video Messages Api
config.videoMessages = config.url + '/api/videomessage/getall/'
config.videoMessagesCount = config.url + '/api/videomessage/getCount/'
config.selectVideoMessage = config.url + '/api/videomessage/get'
config.setPlays = config.url + '/api/videomessage/play'
config.setBackgroundViews = config.url + '/api/videomessage/view'

config.set_auth = config.url + '/api/auth/SetAuth'
config.set_registration = config.url + '/api/user/register'
config.set_installed = config.url + '/api/user/installed'

config.logCustomerActivity = config.url + '/api/activity/customer/'
config.logTwoCustomerActivity = config.url + '/api/activity/twoCustomer/'
config.paymentActivityLog = config.url + '/api/activity/payment/'
config.socialActivityLog = config.url + '/api/activity/social/'

config.getUserCardData = config.url + '/api/getCard'
config.saveUserCardData = config.url + '/api/saveCard'

config.inventoryList = config.url + '/api/inventory/getvehicles'
config.getCurrentVehical = config.url + '/api/inventory/getvehicle'
config.getMakes = config.url + '/api/inventory/getmakes'
config.getModels = config.url + '/api/inventory/getmodels'
config.getTrims = config.url + '/api/inventory/gettrims'
config.getInventoryDynamic = config.url + '/api/inventory/getvehiclesdynamic'
config.getSpecials = config.url + '/api/inventory/getSpecials'

config.getFilterData = config.url + '/api/inventory/getfilters'

config.sendNotification = config.url + '/api/notifications/send'

config.getCustomPage = config.url + '/api/custom-page'

config.getCompanyDepartments = config.url + '/api/company-departments'
config.getPurchased = config.url + '/api/inventory/purchased'
config.getFavorites = config.url + '/api/inventory/favorites'
config.toggleFavorite = config.url + '/api/inventory/favorite'
config.getContactsData = config.url + '/api/customer/contacts'
export default config



//////////////////
// WEBPACK FOOTER
// ./scripts/config/customer.api.js
// module id = 8
// module chunks = 0